<!-- @format -->
<template>
  <div class="template-journey-edit">
    <el-container class="main-container">
      <el-header style="padding: 0">
        <div class="header-bar">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/uxm/templateProject' }">模板项目管理</el-breadcrumb-item>
            <el-breadcrumb-item>{{ projectName }}</el-breadcrumb-item>
            <el-breadcrumb-item>编辑旅程</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-header>
      <el-container class="content-container">
        <el-main class="el-main">
          <div class="journey-edit-wrapper">
            <iframe
              :src="editUrl"
              frameborder="0"
              style="width: 100%; height: calc(100vh - 100px);"
              @load="handleIframeLoad"
            ></iframe>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'TemplateJourneyEdit',
  data() {
    return {
      templateJourneyId: null,
      templateProjectId: null,
      projectName: '',
      editUrl: ''
    }
  },
  created() {
    // 【重要】确保ID正确转换为字符串，避免BigNumber精度丢失
    this.templateJourneyId = this.$route.params.journeyId ? String(this.$route.params.journeyId) : null
    this.templateProjectId = this.$route.query.templateProjectId ? String(this.$route.query.templateProjectId) : null
    this.projectName = decodeURIComponent(this.$route.query.projectName || '')
    
    if (!this.templateJourneyId) {
      console.error('模板旅程ID不存在，无法编辑')
      this.$message.error('模板旅程ID不存在，无法编辑')
      return
    }
    
    // 获取管理端token，传递给用户端页面（实现免登录）
    const adminToken = localStorage.getItem('token') || ''
    
    const userFrontendBaseUrl = 'http://localhost:8080'
    const tokenParam = adminToken ? `&adminToken=${encodeURIComponent(adminToken)}` : ''
    // 【重要】确保ID以字符串形式传递，避免精度丢失
    this.editUrl = `${userFrontendBaseUrl}/journey?journeyId=${this.templateJourneyId}&projectId=${this.templateProjectId}&isTemplate=true${tokenParam}`
    
    console.log('构建编辑页面URL:', {
      templateJourneyId: this.templateJourneyId,
      templateProjectId: this.templateProjectId,
      projectName: this.projectName,
      editUrl: this.editUrl
    })
  },
  methods: {
    handleIframeLoad() {
      console.log('旅程编辑页面加载完成')
    }
  }
}
</script>

<style scoped>
.template-journey-edit {
  width: 100%;
  height: 100vh;
}

.main-container {
  height: 100%;
}

.header-bar {
  padding: 15px 20px;
  background: #fff;
  border-bottom: 1px solid #e4e7ed;
}

.content-container {
  height: calc(100% - 60px);
}

.el-main {
  padding: 0;
  height: 100%;
}

.journey-edit-wrapper {
  width: 100%;
  height: 100%;
}
</style>


